import { arrayOf, isObject, object, string, debug } from '@moleculeone/utils';

export function commonKeys(...args: any) {
  for (const arg of args) {
    debug(isObject, arg);
  }

  const result: string[] = [];

  if (args.length === 0) {
    return result;
  }

  for (const key of Object.keys(args[0])) {
    let ok = true;
    for (let i = 1; i < args.length; i++) {
      if (args[i][key] == null) {
        ok = false;
        break;
      }
    }
    if (ok) {
      result.push(key);
    }
  }
  return debug(arrayOf(string), result);
}

export function allKeys(...args: any) {
  for (const arg of args) {
    debug(object({}), arg);
  }

  const result: string[] = [...new Set(([] as string[]).concat([], ...args.map((g: any) => Object.keys(g))))];
  return debug(arrayOf(string), result);
}

export function substractedKeys(a: any, b: any) {
  debug(isObject, a);
  debug(isObject, b);

  const result: string[] = [];
  for (const k of Object.keys(a)) {
    if (b[k] === undefined) {
      result.push(k);
    }
  }

  return debug(arrayOf(string), result);
}

export function retainKeys(obj: any, keysArr: any) {
  const result: any = {};
  for (const key of keysArr) {
    result[key] = obj[key];
  }
  if (Object.keys(result) === Object.keys(obj)) {
    return obj;
  }
  return result;
}

export function randomElem(random: any, arr: any) {
  return arr[Math.floor(random.quick() * arr.length)];
}

export function randomInt(random: any, min: any, max: any) {
  return Math.floor(random.quick() * (max - min + 1)) + min;
}
